import { Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { BasePage } from './../base.page';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/services/user.service';
import { AuthService } from 'src/app/services/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { WardrobeService } from './../../services/wardrobe.service';
import { PaginatedResponse } from './../../models/paginated-response.model';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { Platform, LoadingController, ToastController, IonInfiniteScroll, ModalController } from '@ionic/angular';
import { ProductCategoryModel, ProductListingParamsModel, ProductModel } from 'src/app/models/wardrobe.model';
import { SubscribeNowModalComponent } from 'src/app/components/subscribe-now-modal/subscribe-now-modal.component';

@Component({
  selector: 'shc-my-wardrobe',
  templateUrl: './my-wardrobe.page.html',
  styleUrls: ['./my-wardrobe.page.scss'],
})
export class MyWardrobePage extends BasePage implements OnInit {
  loading: boolean;
  segmentCurrent: number;
  callInProgress: boolean;
  products: PaginatedResponse<ProductModel>;
  categories: PaginatedResponse<ProductCategoryModel>;
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  params: ProductListingParamsModel = new ProductListingParamsModel();

  constructor(
    protected platform: Platform,
    protected userService: UserService,
    protected authService: AuthService,
    protected translate: TranslateService,
    private errorService: ErrorHandlerService,
    protected loadingCtrl: LoadingController,
    toastController: ToastController,
    private router: Router,
    private wardrobeService: WardrobeService,
    private modalCtrl: ModalController
  ) {
    super(platform, userService, authService, translate, loadingCtrl, toastController);
  }

  ngOnInit() {
    this.params.page = 1;
    if (!this.segmentCurrent) {
      this.segmentCurrent = 0;
    }
    this.getCategories();
    this.getWardrobeList('');
   }

  ionViewWillEnter() {

  }

  segmentChanged(ev): void {
    if (this.callInProgress) {
      return;
    }
    this.params.page = 1;
    this.products = null;
    this.segmentCurrent = parseInt(ev.target.value, 10);
    this.getWardrobeList('');
  }

  getWardrobeList(event) {
    this.showLoader();
    this.loading = true;
    this.callInProgress = true;
    if (this.segmentCurrent === 0) {
      this.params.category_id = null;
    } else {
      this.params.category_id = this.segmentCurrent;
    }
    this.params.user_id = this.user.id;
    this.wardrobeService.productsList(this.params).pipe(
      finalize(() => this.hideLoader())
    ).subscribe(res => {
      this.loading = false;
      this.callInProgress = false;
      if (this.products && this.products.meta) {
        if (this.params.page === 1) {
          this.products = res;
        } else {
          this.products.meta = res.meta;
          this.products.data = [...this.products.data, ...res.data];
        }
      } else {
        this.products = res;
      }
      if (event) {
        event.target.complete();
      }
      this.params.page++;
    }, error => {
      this.loading = false;
      this.callInProgress = false;
      this.errorService.handle(error);
    });
  }

  getCategories() {
    this.wardrobeService.mainCategoriesList({ page: 1, per_page: 40 }).subscribe(res => {
      this.categories = res;
    }, error => {
      this.errorService.handle(error);
    });
  }

  loadData(event): void {
    if (this.products.meta.current_page < this.products.meta.last_page) {
      this.getWardrobeList(event);
    } else {
      this.infiniteScroll.disabled = true;
    }
  }

  routeToAddProduct() {
    if (this.user.products_count >= this.user.allowed_products && (this.user.is_premium !== 1 || this.user.is_subscribed !== 1)) {
      this.subscribeNow();
    } else {
      this.router.navigate(['create-product']);
    }
  }

  async subscribeNow() {
    const modal = await this.modalCtrl.create({
      component: SubscribeNowModalComponent,
      cssClass: 'subscribeNow',
      id: 'subscribeNow',
      keyboardClose: true,
      mode: 'md',
      backdropDismiss: true,
    });
    return await modal.present();
  }

}
